import { useState, useEffect, useCallback } from 'react';
import Localytics from '../utils/localytics';
import { ANALYTICS_EVENTS } from '../../common/constants';

export default function useGoogleOneTap(gAppId, hasLoggedIn) {
  const [oneTapLoginPayload, setOneTapLoginPayload] = useState();
  const { google } = typeof window === 'undefined' ? {} : window;

  const initializeCallback = useCallback((response) => {
    setOneTapLoginPayload(response);
  }, []);

  useEffect(() => {
    if (google) {
      google.accounts.id.initialize({
        client_id: `${gAppId}.apps.googleusercontent.com`,
        callback: initializeCallback,
      });

      // show prompt UI if no user has been found
      if (!hasLoggedIn) {
        google.accounts.id.prompt((notification) => {
          // Record if OneTap was displayed to the user
          if (notification.isDisplayed()) {
            Localytics.event(ANALYTICS_EVENTS.GOOGLE_ONETAP_IMPRESSION);
          }

          // Record if the user gave consent to authenticate
          if (notification.getDismissedReason() === 'credential_returned') {
            Localytics.event(ANALYTICS_EVENTS.GOOGLE_ONETAP_CLICKED);
          }
        });
      }
    }
  }, [hasLoggedIn, gAppId, google, initializeCallback]);

  return oneTapLoginPayload?.credential;
}
